import { Button, Flex, Layout, theme, Tooltip } from "antd"
import {
    PicLeftOutlined,
    PlusOutlined,
    QuestionCircleOutlined
} from "@ant-design/icons"
import { useNavigate } from "react-router-dom"
import { UserControlComponent } from './UserControlComponent.tsx'
import { useGetUser } from "../api/user/user.ts"
import { HEADER_HEIGHT } from "../utils/constants.ts"
import MoneyFlowLogo from '../assets/MoneyFlow_logo.svg?react'

const { Header } = Layout
const { useToken } = theme

export const HeaderComponent = () => {
    const { data: userInfo } = useGetUser()
    const navigate = useNavigate()
    const { token } = useToken()

    return <Header
        style={{
            height: HEADER_HEIGHT,
            padding: `0 ${token.marginLG}px`,
            background: token.colorBgContainer,
            borderBottom: `1px solid ${token.colorSplit}`
        }}
    >
        <Flex
            align="center"
            justify="space-between"
            gap={token.margin}
            style={{ height: 60, padding: `0 ${token.padding}` }}>
            <MoneyFlowLogo onClick={() => navigate('/')} style={{ color: 'var(--ant-color-text)', cursor: 'pointer' }} />

            <Flex gap={token.padding}>
                <Button onClick={() => navigate('/')} icon={<PlusOutlined />}/>
                <Button onClick={() => navigate('/tasks')} icon={<PicLeftOutlined />}/>
                {!!userInfo && <Tooltip title="Need help? Click here for support">
                    <Button target="_blank" href={userInfo.supportUrl} icon={<QuestionCircleOutlined />}/>
                </Tooltip>}
                <UserControlComponent/>
            </Flex>
        </Flex>
    </Header>
}
